import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { Input, Select, formatDisplayValue } from '../TowerEditor';
// import palette from '../../../lib/styles/palette';
// import { UNITWEIGHT_STAIR } from './constants';
import { changeBody, summaryWeight } from '../../../modules/tower/towerWriteSlice';

const StairForm = ({ stair, size }) => {
    const dispatch = useDispatch();
    const [newStair, setNewStair] = useState(stair || {});

    const handleChange = (e) => {
        const { name, value } = e.target;

        setNewStair((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const unitWeigtMap = useRef({
        'N/A': 0,
        '600W_C200x80': 156.5,
    });

    /* height 설정 */
    useEffect(() => {
        if (!size?.main?.height) {
            return;
        }

        let stairHeight;
        if (!newStair.stairType || newStair.stairType === 'N/A') {
            stairHeight = 0
        } else {
            stairHeight = size.main.height * 1.5
        }
    
        setNewStair(prev => ({
            ...prev,
            stairHeight,
        }));
    }, [newStair.stairType, size?.main?.height]);

    /* unitWeight 산정 */
    useEffect(() => {
        if (!newStair.stairType) {
            return;
        }

        setNewStair(prev => ({
            ...prev,
            unitWeight: unitWeigtMap.current[newStair.stairType],
        }))
    }, [newStair.stairType]);

    /* 내부 계산 */
    useEffect(() => {
        const weight = Math.ceil(newStair.stairHeight * newStair.unitWeight);

        setNewStair(prev => ({
            ...prev,
            weight: weight || 0,
        }));
    }, [size?.main?.height, newStair.stairHeight, newStair.unitWeight]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        // if (!newStair.weight) {
        //     return;
        // }
        dispatch(changeBody({
            key: 'stair',
            value: newStair,
        }))
    }, [dispatch, newStair]);
    
    /* 리덕스에 weightSum 쓰기 */
    useEffect(() => {
        if (!newStair.weight) {
            return;
        }
        dispatch(
            summaryWeight({
                key: 'stair',
                value: newStair.weight,
            }),
        );
    }, [dispatch, newStair.weight]);


    return (
        <>
            <tr>
                <td>Stair</td>
                <td colSpan={3} className="input-inside-td">
                    {/* <span style={{ fontSize: '0.8rem', color: `${palette.gray[8]}` }}>※ 600W, C200x80</span> */}
                    <Select name="stairType" value={newStair.stairType} onChange={handleChange}>
                        <option value="" selected disabled hidden>Select...</option>
                        <option value="N/A">N/A</option>
                        <option value="600W_C200x80">600W, C200x80</option>
                    </Select>
                </td>
                <td className="input-inside-td">
                    <Input name="stairHeight" value={formatDisplayValue(newStair.stairHeight)} onChange={handleChange} />
                </td>
                <td>m</td>
                <td className="right-align">{formatDisplayValue(newStair.unitWeight)}</td>
                <td className="right-align">{formatDisplayValue(newStair.weight)}</td>
            </tr>
            <tr>
                <td className="spacer"></td>
            </tr>
        </>
    );
};

export default StairForm;
